import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// 动画插件
import lottie from 'vue-lottie';
Vue.component('lottie', lottie)

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

// 公共css
import '@/assets/css/common.css'

// 公共自定义字体
import '@/assets/text/text.css'

// 引入animate.css
import animated from 'animate.css'

// js-cookie
import Cookies from 'js-cookie'
Vue.prototype.Cookies = Cookies

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
